var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10417 10.2083C5.10412 10.3032 5.13051 10.3962 5.18037 10.4769C5.23023 10.5576 5.30158 10.6228 5.38643 10.6652L6.40726 11.1756C6.4851 11.2145 6.57159 11.2328 6.65851 11.2289C6.74544 11.2249 6.82991 11.1989 6.90391 11.1531C6.97792 11.1073 7.03899 11.0434 7.08133 10.9674C7.12367 10.8913 7.14588 10.8058 7.14584 10.7188V7.14583C7.14595 6.89286 7.23999 6.64894 7.40972 6.46136L11.0965 2.38365C11.1625 2.31043 11.206 2.21964 11.2216 2.12225C11.2371 2.02487 11.2242 1.92505 11.1842 1.83488C11.1442 1.74472 11.079 1.66805 10.9964 1.61417C10.9138 1.56028 10.8174 1.53148 10.7188 1.53125H1.53125C1.43254 1.53129 1.33596 1.55994 1.2532 1.61375C1.17045 1.66756 1.10507 1.74421 1.06499 1.83442C1.02491 1.92463 1.01184 2.02452 1.02738 2.122C1.04292 2.21948 1.08639 2.31037 1.15252 2.38365L4.84028 6.46136C5.01002 6.64894 5.10405 6.89286 5.10417 7.14583V10.2083Z",
    stroke: "#8B1818",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterred);
export default __webpack_public_path__ + "static/media/filterred.a591e1323549b1d1b1684025bba4a08f.svg";
export { ForwardRef as ReactComponent };